/*
  Casamara free-shipping bar (260929). Keeps every [data-cc-shipbar] (header, cart page,
  cart drawer) in step with the live cart. Markup and first paint: snippets/casamara-ship-bar.liquid.

  Update paths, in order of preference:
    1. Dawn's pub/sub cartUpdate event (cart page quantity changes, cart drawer, product form).
       When the event carries a full cart (/cart/change.js) it is used directly; otherwise
       /cart.js is fetched.
    2. Any fetch or XHR to /cart/add, /cart/change, /cart/update or /cart/clear (flavor-pdp's
       own add, the Loop widget, other apps) triggers a /cart.js re-read.
    3. pageshow from the back/forward cache re-reads /cart.js.
  Reads cart totals only; never inventory.
*/
(function () {
  if (window.__ccShipBar) return;
  window.__ccShipBar = true;

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function bars() { return document.querySelectorAll('[data-cc-shipbar]'); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function moneyShort(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  /* 260929 (shipping agent, test 19): subscription lines ship free but do not count toward
     the threshold; one-time lines pay per pack unless they ALONE reach it. Compared amount =
     one-time lines after line discounts, less the whole order-level discount (under-promises
     only). Same rule as snippets/casamara-ship-bar.liquid. */
  function oneTime(cart) {
    var sum = 0, lines = 0;
    (cart.items || []).forEach(function (i) {
      if (i.selling_plan_allocation) return;
      lines++;
      sum += (typeof i.final_line_price === 'number') ? i.final_line_price : (i.line_price || 0);
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { sum -= (d.total_allocated_amount || 0); });
    return { sum: Math.max(0, sum), lines: lines };
  }
  function textFor(cart, threshold) {
    if (!cart || !cart.item_count) return { state: 'empty', text: 'Free shipping over ' + moneyShort(threshold) };
    var ot = oneTime(cart);
    if (ot.lines === 0 || ot.sum >= threshold) return { state: 'free', text: 'You’ve got free shipping!' };
    return { state: 'under', text: 'Almost there. Add ' + money(threshold - ot.sum) + ' for free shipping.' };
  }

  function apply(cart) {
    bars().forEach(function (el) {
      var t = parseInt(el.getAttribute('data-threshold'), 10);
      if (!(t > 0)) return;
      var r = textFor(cart, t);
      var span = el.querySelector('[data-cc-shipbar-text]') || el;
      if (span.textContent !== r.text) span.textContent = r.text;
      el.setAttribute('data-state', r.state);
    });
  }

  var timer = null;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  function refresh() {
    if (!bars().length || !nativeFetch) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(apply)
        .catch(function () {});
    }, 150);
  }

  function isFullCart(d) { return d && typeof d.total_price === 'number' && typeof d.item_count === 'number' && Array.isArray(d.items); }

  /* 1. Dawn pub/sub */
  /* constants.js declares PUB_SUB_EVENTS with const, so it is a global binding but not a
     window property: test and read it by name. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && isFullCart(e.cartData)) apply(e.cartData); else refresh();
    });
  }

  /* 2. Any cart write, however it is made */
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var p = nativeFetch(input, init);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_WRITE.test(url)) p.then(function () { refresh(); }, function () {});
      } catch (e) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_WRITE.test(String(url))) this.addEventListener('loadend', refresh);
      } catch (e) {}
      return open.apply(this, arguments);
    };
  }

  /* 3. Back/forward cache */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
